/**
 * Lightweight right-click context menu.
 *
 * Usage:
 *   showContextMenu(x, y, [
 *     { label: '▶ Начать', action: () => ... },
 *     { label: '🗑 Удалить', action: () => ..., danger: true },
 *   ]);
 *
 * Auto-dismisses on outside click, Esc, or scroll. One singleton menu lives
 * on document.body and is re-populated on each call.
 */

let _menuEl = null;

function ensureEl() {
  if (_menuEl) return _menuEl;
  _menuEl = document.createElement('ul');
  _menuEl.className = 'ctx-menu';
  _menuEl.setAttribute('role', 'menu');
  _menuEl.hidden = true;
  document.body.appendChild(_menuEl);

  // Dismiss handlers — installed once, kept for the lifetime of the page.
  document.addEventListener('click', (e) => {
    if (!_menuEl.hidden && !_menuEl.contains(e.target)) hideContextMenu();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !_menuEl.hidden) {
      hideContextMenu();
      e.stopPropagation();
    }
  });
  window.addEventListener('scroll', () => hideContextMenu(), true);
  return _menuEl;
}

export function showContextMenu(x, y, items) {
  const el = ensureEl();
  el.innerHTML = '';
  for (const item of items.filter(Boolean)) {
    const li = document.createElement('li');
    li.className = 'ctx-menu-item' + (item.danger ? ' danger' : '');
    li.textContent = item.label;
    li.setAttribute('role', 'menuitem');
    if (item.disabled) {
      li.classList.add('disabled');
    } else {
      li.addEventListener('click', () => {
        // keepOpen: action runs, menu stays — outside-click/Esc still close
        // it via the document handlers in ensureEl(). Used by multi-toggle
        // menus (e.g. column visibility) where users want to flip several
        // checkboxes without reopening the menu each time.
        if (!item.keepOpen) hideContextMenu();
        item.action();
        if (item.keepOpen && typeof item.getLabel === 'function') {
          li.textContent = item.getLabel();
        }
      });
    }
    el.appendChild(li);
  }
  // Show first to measure, then clamp inside viewport.
  el.style.left = '0px';
  el.style.top  = '0px';
  el.hidden = false;
  const rect = el.getBoundingClientRect();
  const maxX = window.innerWidth  - rect.width  - 4;
  const maxY = window.innerHeight - rect.height - 4;
  el.style.left = Math.min(x, maxX) + 'px';
  el.style.top  = Math.min(y, maxY) + 'px';
}

export function hideContextMenu() {
  if (_menuEl) _menuEl.hidden = true;
}
